import { FC } from 'react'

import styled from 'styled-components'
import { useParams } from 'react-router-dom'

import { useGetMetaAdsCampaignByIdQuery } from 'src/Redux/adsCampaignApi'
import { ScheduleSettingsHeader } from 'src/Components/ScheduleSettingsHeader'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { usePaymentCancelledAdsEvents } from 'src/Hooks/usePaymentCancelledAdsEvents'

import { AdsTrackParameters } from './components/AdsTrackParameters'
import { AdsScheduleModals } from './components/AdsScheduleModals'
import { AdsBudget } from './components/AdsBudget'
import { AdsAdSettings } from './components/AdsAdSettings'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`
const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  @media screen and (min-width: 768px) {
    align-items: flex-start;
    flex-direction: row;
    align-self: stretch;
  }
`

const LeftBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`

export const AdsScheduleSettingsPage: FC = () => {
  const { number } = useParams()
  const { data } = useGetMetaAdsCampaignByIdQuery(Number(number))
  usePaymentCancelledAdsEvents()

  return (
    <>
      <AdsScheduleModals
        visualQuestions={data?.adVisualDescription}
        strategyType={data?.strategy}
        campaignId={Number(data?.id)}
        visualType={data?.visualType}
      />
      <Container>
        <ScheduleSettingsHeader
          artistName={data?.ownerName}
          trackCover={data?.coverUrl}
          trackName={data?.resourceName}
          platform={CampaignPlatformTypeEnum.META}
          startDate={''}
          todayEnable={true}
          isEditable={false}
        />

        <Wrapper>
          <LeftBlock>
            <AdsTrackParameters adCampaignData={data} />
            <AdsAdSettings
              countries={data?.countries}
              visualType={data?.visualType}
            />
          </LeftBlock>

          <AdsBudget />
        </Wrapper>
      </Container>
    </>
  )
}
